/* eslint-disable no-param-reassign */
/* eslint-disable import/no-unresolved */
import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import OrderHowMessage from './OrderHowMessage';

import RightModalLayout from '../../../../layouts/Modal/RightModalLayout';
import { SIDEBAR_ACTIONS } from '../../../../../constants/actionsConstants';
import { useSendPaymentLinks } from '../../hooks/useSendPaymentLinks';
import { toSidebarPlatformKey } from '../../../../../services/inbox/inboxMsChatPlatform';

const SendByModal = ({
  order,
  platform,
  onSendPaymentLink
}) => {
  const { t } = useTranslation('Orders');
  const { t: tCommon } = useTranslation('Common');
  const dispatch = useDispatch();
  const basePlatform = toSidebarPlatformKey(platform) || platform;

  const onClose = () => {
    dispatch({
      type: SIDEBAR_ACTIONS.CLOSE_SIDEBAR
    });
  };

  const {
    handleSendBy,
  } = useSendPaymentLinks({ order, platform, onSendPaymentLink, onClose });


  return (
    <div className="tw-wrapper">
      <RightModalLayout
        title={`${t('sendBy.title')} ${t(`sendBy.${basePlatform}`)}`}
        closeAction={onClose}
        submitAction={handleSendBy}
        submitLabel={`${tCommon('actions.send')}`}
      >
        <div className="tw-wrapper">
          <div className="tw-flex tw-flex-col tw-gap-6">
            <div className="tw-flex tw-flex-col tw-gap-6 tw-overflow-y-auto tw-break-words">
              <div className="tw-flex tw-flex-col tw-gap-6">
                <OrderHowMessage order={order} paymentMethods={[]} />
              </div>
            </div>
          </div>
        </div>
      </RightModalLayout>
    </div>
  );
};

export default SendByModal;

